import { motion } from "framer-motion"; // Added useState
import {
  Globe,
  Shield,
  Briefcase,
  Key,
  BatteryCharging,
  FileText,
  Leaf,
  Anchor,
  Truck as TruckIcon,
  Warehouse as WarehouseIcon,
  Handshake,
  Umbrella,
} from "lucide-react";
import Footer from "./Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ImageSlider from "./ImageSlider";
import StatusGallery from "./StatusGallery";
import TravelTimesCard from "./TravelTimeCard";
import MasterPlan from "./MasterPlan";
import { useLanguage } from "../LanguageContext";
import { translations } from "../translations";
import DeveloperInfoCard from "./DeveloperInfoCard";

// Animation Variants
const fadeIn = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const icons = [
  <Globe className="w-8 h-8 text-blue-500" />,
  <Briefcase className="w-8 h-8 text-blue-500" />,
  <Key className="w-8 h-8 text-blue-500" />,
  <BatteryCharging className="w-9 h-9 text-blue-500" />,
  <FileText className="w-8 h-8 text-blue-500" />,
  <Shield className="w-8 h-8 text-blue-500" />,
  <Leaf className="w-8 h-8 text-blue-500" />,
  <Anchor className="w-8 h-8 text-blue-500" />,
  <TruckIcon className="w-8 h-8 text-blue-500" />,
  <WarehouseIcon className="w-8 h-8 text-blue-500" />,
  <Handshake className="w-8 h-8 text-blue-500" />,
  <Umbrella className="w-8 h-8 text-blue-500" />,
];

const Project = () => {
  const { language } = useLanguage();
  return (
    <>
      <section
        id="about"
        className="py-12 md:py-16 lg:py-20 xl:py-24 sm:pt-20 pt-20 bg-white max-w-6xl items-center mx-auto"
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Overview Section */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-900 ">
            {translations[language].Overview}
          </h2>
          <div className="mt-6 md:mt-8 space-y-4">
            {translations[language].OverviewTexts.map((text, index) => (
              <motion.p
                key={index}
                className="text-sm sm:text-base text-gray-700"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeIn}
              >
                {text}
              </motion.p>
            ))}
          </div>

          {/* Master Plan Section */}
          <MasterPlan />

          {/* Detail Section */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-12 text-center text-gray-900">
            {translations[language].Details}
          </h2>
          <div className="mt-6 md:mt-8 border border-gray-300 rounded-lg p-6 shadow-md">
            <div className="space-y-8">
              {(translations[language]?.detailItems || []).map(
                (item, index) => (
                  <div
                    key={index}
                    className={`grid grid-cols-1 md:grid-cols-2 gap-6 items-center ${
                      index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                    }`}
                  >
                    <div className="flex items-center gap-4">
                      {icons[index]} {/* This remains unchanged */}
                      <h3 className="text-xl font-semibold text-gray-900">
                        {item.title}
                      </h3>
                    </div>
                    <p className="text-sm sm:text-base text-gray-700">
                      {item.description}
                    </p>
                  </div>
                )
              )}
            </div>
          </div>

          {/* Project Designs */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-12 text-center text-gray-900">
            {translations[language].ProjectDesigns}
          </h2>
          <StatusGallery />

          {/* Project Location */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-12 text-center text-gray-900">
            {translations[language].ProjectLocation}
          </h2>
          <TravelTimesCard />
          {/* Developer Information */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-12 text-center text-gray-900">
            {translations[language].developerInfo.title}
          </h2>
          <DeveloperInfoCard />

          {/* Current Status */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-12 text-center text-gray-900">
            {translations[language].CurrentStatus}
          </h2>
          <ImageSlider />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Project;
